export const DAO_CODE = 'DASHBOARD_CONSULTANT_WORKLOAD' + '_DAO';
